import { defineComponent as _defineComponent } from 'vue'

import { ApiGetLoadAddStatusType, ApiGetLoadAddStatus } from "@/modules/types/apiLoadStatusType";
import ApiErrorDisplay from "./ApiErrorDisplay.vue";
import ApiLoadingDisplay from "./ApiLoadingDisplay.vue";

interface Props {
	/**
	 * APIステータス。
	 */
	status: ApiGetLoadAddStatusType;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    status: { type: null, required: true }
  },
  setup(__props: any, { expose }) {
  expose()

const props = __props as {
	/**
	 * APIステータス。
	 */
	status: ApiGetLoadAddStatusType;
}
/**
 * GETリクエストでの、追加読み込み分表示機能付きAPIローディング表示コンテンツ。
 */


/**
 * API成功時の表示をしていいかどうか。
 */
const isApiSuccessContentsDisplay = (): boolean => {
	// API処理成功状態であればOK
	if (props.status === ApiGetLoadAddStatus.success) {
		return true;
	}
	// 追加読み込みのAPIステータスは、API成功時の表示の後ろに追加表示されるので表示してOK
	if (props.status === ApiGetLoadAddStatus.addLoading || props.status === ApiGetLoadAddStatus.addError) {
		return true;
	}

	return false;
};

const __returned__ = { props, isApiSuccessContentsDisplay, ApiGetLoadAddStatus, ApiErrorDisplay, ApiLoadingDisplay }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})